<template>
  <div class="home">
    <div class="blog-loop">
      <APost v-for="(post,index) in posts" :key="post.slug + '_' + index" :post="post"/>
    </div>
  </div>
</template>

<script>
// butter CMS
import Butter from "buttercms";
const butter = Butter("45cafa75f025d3699ac7a4fec5ef3850db278cc7");

// components
import APost from "@/components/APost";

export default {
  name: "home",
  metaInfo: {
    // Children can override the title.
    title: "My Blog",
    titleTemplate: "%s ← Mark Bloomfield's Blog"
  },
  data() {
    return {
      posts: [],
      single: false
    };
  },
  components: {
    APost
  },
  methods: {
    getPosts() {
      butter.post
        .list({ page: 1, page_size: 10 })
        .then(resp => {
          this.posts = resp.data.data;
        })
        .catch(resp => {
          console.log(resp);
        });
    }
  },
  created() {
    this.getPosts();
  }
};
</script>

<style scoped>
.blog-loop {
  max-width: 850px;
  margin-left: auto;
  margin-right: auto;
}
</style>
